module.exports = __webpack_public_path__ + "assets/devices/LED_KEYPAD-c5e8b92954cf65b0a241ca5669a46b58.svg";